import { app_name } from "../config/config";
import styles from "../styles/footer.module.scss";

export default function Footer() {
  return (
    <div className={styles.container}>
      <div className={styles.footerLabel}>Powered by {app_name}</div>
    </div>
  );
}
